import React, {FunctionComponent} from 'react';
import './Stepper.less';
import {Step} from '../step/Step';
import times from 'lodash/times';

interface StepperProps {
	currentStep: number;
	maxSteps: number;
	currentStepText: string;
}

export const Stepper: FunctionComponent<StepperProps> = ({currentStep, maxSteps, currentStepText}) => {
	let stepperWidth = (maxSteps + 2) * 10;
	if (stepperWidth > 100) {
		stepperWidth = 100;
	}
	return (
		<div
			className="stepper"

		>
			{
				maxSteps > 1 && (
					<div
						className="stepper__header"
						style={{'width': stepperWidth + '%'}}
					>
						{
							(
								times(maxSteps, i => (
									<React.Fragment key={i}>
										<Step isActive={currentStep === i} key={i}/>
										{(i < maxSteps - 1) && <div className="stepper__line"/>}
									</React.Fragment>
								))
							)
						}
					</div>
				)
			}
			<div className="stepper__text">{currentStepText}</div>
		</div>
	);
};
